/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import _ from 'underscore';
const HtmlXSSUtils = require('gemini/lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils');

class UnescapedString extends Component {
	render() {
		if(Array.isArray(this.props.children) || !this.props.children.type) {
			throw new Error('must contain exactly 1 child elements');
		}

		const CustomComponent = this.props.children.type;
		const forwardedProps = _.omit(this.props.children.props, 'children');

		return (
			<CustomComponent {...forwardedProps} dangerouslySetInnerHTML={ { __html: HtmlXSSUtils.sanitizeHtml(this.props.children.props.children) } }></CustomComponent>
		);
	}
}

UnescapedString.propTypes = {
	children: PropTypes.any
};

export default UnescapedString;



// WEBPACK FOOTER //
// ./src/js/util/UnescapedString.js